(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundles"] && !Shopify.designMode) return;
  try {
    
// =====================================================
// BUNDLE SECTION JAVASCRIPT
// Handles: pricing totals, variant updates, ATC
// =====================================================
(function () {
  'use strict';

  class BundleSection {
    constructor(container) {
      this.container     = container;
      this.sectionId     = container.dataset.sectionId;
      this.discountPct   = parseFloat(container.dataset.discount) || 0;
      this.cards         = Array.from(container.querySelectorAll('[data-product-id]'));
      this.addBtn        = container.querySelector(`#BundleAddToCart-${this.sectionId}`);
      this.totalOrigEl   = container.querySelector('.js-bundle-original-total');
      this.totalSaleEl   = container.querySelector('.js-bundle-sale-total');

      this.lineItems = {};   // variantId → { variantId, originalPrice, finalPrice }

      this.init();
    }

    init() {
      this.cards.forEach(card => {
        const variantSelect = card.querySelector('.bundle-section__variant-select');
        if (variantSelect) {
          variantSelect.addEventListener('change', (e) => this.onVariantChange(card, e.target.value));
        }
        // Register initial line item
        this.registerCard(card, card.dataset.variantId);
      });

      this.updateTotals();

      if (this.addBtn) {
        this.addBtn.addEventListener('click', () => this.addBundleToCart());
      }
    }

    registerCard(card, variantId) {
      const originalPrice = parseInt(card.dataset.originalPrice, 10) || 0;
      if (!originalPrice) return; // block has no product assigned yet — skip
      const discount      = Math.round(originalPrice * this.discountPct / 100);
      const finalPrice    = originalPrice - discount;

      // Update displayed sale price in the card
      const salePriceEl = card.querySelector('.bundle-section__sale-price');
      if (salePriceEl) salePriceEl.textContent = this.formatMoney(finalPrice);

      this.lineItems[card.dataset.productId] = {
        variantId,
        originalPrice,
        finalPrice,
      };
    }

    onVariantChange(card, newVariantId) {
      // Fetch variant price via AJAX
      const productId = card.dataset.productId;
      fetch(`/products/${this.getProductHandle(card)}.js`)
        .then(r => r.json())
        .then(data => {
          const variant = data.variants.find(v => v.id == newVariantId);
          if (!variant) return;
          card.dataset.variantId    = newVariantId;
          card.dataset.originalPrice = variant.price;
          const discount   = Math.round(variant.price * this.discountPct / 100);
          const finalPrice = variant.price - discount;

          const salePriceEl = card.querySelector('.bundle-section__sale-price');
          const origPriceEl = card.querySelector('.bundle-section__original-price');
          if (salePriceEl) salePriceEl.textContent = this.formatMoney(finalPrice);
          if (origPriceEl) origPriceEl.textContent  = this.formatMoney(variant.price);

          this.lineItems[productId] = { variantId: newVariantId, originalPrice: variant.price, finalPrice };
          this.updateTotals();
        })
        .catch(err => console.warn('[Bundle] Variant fetch error', err));
    }

    getProductHandle(card) {
      // Grab handle from the product title link href
      const link = card.querySelector('.bundle-section__product-title');
      if (!link) return '';
      return link.getAttribute('href').replace('/products/', '').split('?')[0];
    }

    updateTotals() {
      let origTotal = 0;
      let saleTotal = 0;
      Object.values(this.lineItems).forEach(item => {
        origTotal += (item.originalPrice || 0);
        saleTotal += (item.finalPrice    || 0);
      });

      const hasItems = Object.keys(this.lineItems).length > 0;
      if (this.totalOrigEl) this.totalOrigEl.textContent = hasItems ? this.formatMoney(origTotal) : '';
      if (this.totalSaleEl) this.totalSaleEl.textContent = hasItems ? this.formatMoney(saleTotal) : '';
    }

    addBundleToCart() {
      if (!this.addBtn) return;

      const items = Object.values(this.lineItems).map(item => ({
        id: parseInt(item.variantId, 10),
        quantity: 1,
      }));

      if (!items.length) return;

      this.setLoading(true);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      })
        .then(r => {
          if (!r.ok) throw new Error('Cart add failed');
          return r.json();
        })
        .then(() => {
          // Refresh mini-cart / header count — works with Dawn's cart drawer
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          // Trigger Dawn's built-in cart drawer open
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          } else {
            // Fallback: reload page
            window.location.reload();
          }

          // Success animation on button
          this.addBtn.querySelector('.bundle-section__btn-text').textContent =
            window.bundleStrings?.added || '✓ Added to cart!';
          setTimeout(() => {
            if (this.addBtn.querySelector('.bundle-section__btn-text')) {
              this.addBtn.querySelector('.bundle-section__btn-text').textContent =
                window.bundleStrings?.cta || 'Add Bundle to Cart';
            }
          }, 2500);
        })
        .catch(err => {
          console.error('[Bundle] Add to cart error', err);
          alert('Something went wrong. Please try again.');
        })
        .finally(() => this.setLoading(false));
    }

    setLoading(state) {
      const btnText   = this.addBtn.querySelector('.bundle-section__btn-text');
      const btnLoader = this.addBtn.querySelector('.bundle-section__btn-loader');
      this.addBtn.disabled = state;
      if (btnText)   btnText.style.display   = state ? 'none' : '';
      if (btnLoader) btnLoader.style.display = state ? 'flex' : 'none';
    }

    formatMoney(cents) {
      // Use Shopify's global formatter if available
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
      }
      return '$' + (cents / 100).toFixed(2);
    }
  }

  // Boot all bundle sections on the page
  function bootBundles() {
    document.querySelectorAll('[data-section-id][id^="Bundle-"]').forEach(el => {
      if (!el._bundleInstance) {
        el._bundleInstance = new BundleSection(el);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', bootBundles);
  // Support Shopify section re-rendering in the editor
  document.addEventListener('shopify:section:load', bootBundles);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
